import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import "./UnsubscribeDraft.css"; // reuse same styles

const UnsubscribeMarketing = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | success | error | invalid

  useEffect(() => {
    if (!token) { setStatus("invalid"); return; }
    axios
      .get(`${config.apiUrl}/api/v1/unsubscribe-marketing?token=${token}`)
      .then(() => setStatus("success"))
      .catch((err) => {
        const msg = err?.response?.data?.message || "";
        setStatus(msg.includes("already") ? "success" : "error");
      });
  }, [token]);

  return (
    <div className="unsub-page">
      <div className="unsub-card">
        <div className="unsub-logo">dmyor</div>

        {status === "loading" && (
          <>
            <div className="unsub-icon unsub-icon-spin">◌</div>
            <p className="unsub-msg">Processing...</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="unsub-icon">✓</div>
            <h1 className="unsub-title">You're unsubscribed.</h1>
            <p className="unsub-body">
              We won't send you any more marketing updates. Your account
              and any visions you're building are unaffected.
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <div className="unsub-icon unsub-icon-err">✕</div>
            <h1 className="unsub-title">Something went wrong.</h1>
            <p className="unsub-body">
              This unsubscribe link may be invalid. Reply to the email
              and we'll sort it out.
            </p>
          </>
        )}

        {status === "invalid" && (
          <>
            <div className="unsub-icon unsub-icon-err">!</div>
            <h1 className="unsub-title">Invalid link.</h1>
            <p className="unsub-body">
              This unsubscribe link is missing a token. Please use the link
              from the email we sent you.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribeMarketing;
